import { motion } from 'framer-motion';
import { Shield, TrendingUp, Landmark } from 'lucide-react';

/* ═══════════════════════════════════════════
   EDITABLE: Feature boxes content
   - Edit title, description, icon for each box
═══════════════════════════════════════════ */
const features = [
  {
    icon: Shield,
    title: 'Insurance & Protection',
    description: 'Comprehensive coverage for health, vehicle, property, and life — tailored to safeguard your family\'s future.',
  },
  {
    icon: TrendingUp,
    title: 'Investment & Growth',
    description: 'Strategic mutual fund planning and portfolio management to grow your wealth systematically over time.',
  },
  {
    icon: Landmark,
    title: 'Tax & Compliance',
    description: 'Expert Income Tax and GST planning services to reduce liabilities and ensure full compliance.',
  },
];

export const FeatureBoxes = () => {
  return (
    <section data-testid="feature-boxes-section" className="relative z-10 -mt-16 md:-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              data-testid={`feature-box-${index}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="bg-white rounded-xl p-8 shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-gray-100 group"
            >
              <div className="w-14 h-14 bg-[#0A192F] rounded-lg flex items-center justify-center mb-5 group-hover:bg-[#D4AF37] transition-colors duration-300">
                <feature.icon size={24} className="text-[#D4AF37] group-hover:text-[#0A192F] transition-colors" />
              </div>
              <h3 className="font-['Playfair_Display'] text-lg font-bold text-[#0A192F] mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-[#49566B] leading-relaxed font-['Outfit']">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
